import loadLiff from "./load_liff.js"
import querySubscription from "./subscription"

// อ่าน ?redirect= ปลอดภัย (กัน open-redirect ต้องเป็น path สัมพัทธ์ขึ้นต้น / เดียว)
function safeRedirect(defaultRedirect="/profile") {
  const requested = new URLSearchParams(window.location.search).get("redirect")
  return (requested && /^\/[^/\\]/.test(requested)) ? requested : defaultRedirect
}

// readRedirectParam=true เฉพาะหน้า /liff (ตัวสับราง rich menu) — อ่าน ?redirect= แล้วพาไปหน้านั้น
// หน้าเนื้อหาอื่น (available_packages ฯลฯ) เรียกโดยไม่ส่งอะไร → redirectUrl=null → แค่ตั้ง session แล้วอยู่หน้าเดิม
// inClientOnly=true (ค่าปริยาย): ทำ LIFF flow เฉพาะในเบราว์เซอร์ในแอป LINE เท่านั้น
//   หน้าเนื้อหาพวกนี้ฝังอยู่ใน bundle เดียวกับเว็บปกติ — บนเดสก์ท็อป/เบราว์เซอร์นอกแอป
//   liff.login() จะเด้งทุกคนไป access.line.me ทั้งที่มี session เว็บอยู่แล้ว
//   (สมาชิกที่ล็อกอิน Google ก็โดนบังคับล็อกอิน LINE ทุกครั้งที่ token LIFF ใน localStorage หมด)
//   หน้า /liff ทางเข้า login โดยตรงเท่านั้นที่ส่ง false — ต้องทำ flow เสมอแม้เปิดนอกแอป
export function initLiffAndSetSessionSubscription(pageId, redirectUrl=null, readRedirectParam=false, inClientOnly=true) {
  let liffId = document.getElementById("liffid").content
  let page = document.getElementById(pageId)
  if (page == null) { return }

  // เซิร์ฟเวอร์ล็อกอินให้แล้ว → หน้าเนื้อหาไม่ต้องแตะ LIFF SDK เลย (ไม่โหลด SDK ด้วย)
  // liff.init() ใน LIFF browser จะ auto-login (redirect ไป access.line.me) เองเมื่อ token
  // ในเครื่องใช้ไม่ได้ — ห้ามด้วยโค้ดไม่ได้ เครื่องที่ token เสียจะโดนลากไปจอ LINE Login 400
  // ทั้งที่เพิ่งโหลดหน้าจากเซิร์ฟเวอร์สำเร็จ; session ต่ออายุฝั่งเซิร์ฟเวอร์ทุก request อยู่แล้ว
  if (inClientOnly && document.getElementById("member-authed")?.content === "true") { return }
  // นอกแอป LINE ไม่ต้องโหลด SDK มาเช็ค isInClient() — UA ของเบราว์เซอร์ในแอป LINE มี "Line/" เสมอ
  if (inClientOnly && !/\bLine\//i.test(navigator.userAgent)) { return }

  loadLiff()
    .then((liff) => {
      if (inClientOnly && !liff.isInClient()) { return }
      return liff.init({ liffId: liffId }).then(async () => {
        // token LIFF หมดอายุ: ห้ามเรียก liff.login() จากหน้าเนื้อหา (inClientOnly=true) เด็ดขาด —
        // login() ใช้ URL หน้าปัจจุบันเป็น redirect_uri ซึ่งอยู่นอก LIFF endpoint (/liff)
        // LINE จะตอบ 400 Bad Request ทันที (สมาชิกกดซื้อ/เพิ่มดวงแล้วเด้งไปเจอจอ 400)
        // แค่ข้ามการต่ออายุ cookie ไป — session ฝั่งเซิร์ฟเวอร์ (30 วัน) ยังล็อกอินอยู่ตามเดิม
        if (!liff.isLoggedIn()) {
          if (inClientOnly) { return }

          // ใน LIFF browser ห้ามเรียก liff.login() (เอกสาร LINE ระบุตรง ๆ — auto-login ต้องมาจาก
          // liff.init เท่านั้น เรียกเองจะเจอจอ LINE Login 400) ถ้า init จบแล้ว isLoggedIn ยัง false
          // = handshake ของเครื่องนั้นพัง → เปิด LIFF URL ถาวรให้ LINE เริ่ม auto-login ใหม่ 1 ครั้ง
          // (กันลูปด้วย sessionStorage) ถ้ายังไม่ผ่านอีกก็ขึ้นปุ่มลองใหม่ ไม่ปล่อยไปตายที่จอ 400
          if (liff.isInClient()) {
            if (!sessionStorage.getItem("liffRestarted")) {
              sessionStorage.setItem("liffRestarted", "1")
              const redirect = new URLSearchParams(window.location.search).get("redirect")
              window.location.replace(`https://liff.line.me/${liffId}` +
                (redirect ? `?redirect=${encodeURIComponent(redirect)}` : ""))
            } else {
              showLiffLoginProblem(liffId)
            }
            return
          }

          liff.login() // เบราว์เซอร์นอกแอปเท่านั้น — หน้า /liff คือ endpoint เอง redirect_uri ตรงเสมอ
          return
        }
        sessionStorage.removeItem("liffRestarted") // login ผ่านแล้ว เคลียร์ตัวกันลูปไว้รอบหน้า

        // ยิงขนานกัน — getProfile() คุยกับ LINE ผ่านเน็ต ไม่ต้องรอ getAccessToken() ให้เสร็จก่อน
        const [accessToken, profile] = await Promise.all([
          liff.getAccessToken(),
          liff.getProfile(),
        ])

        // Save line access_token to cookie
        // max-age 30 วันเท่า session cookie — ไม่งั้นหายตอนปิดเบราว์เซอร์ ต้องล็อกอิน LINE ใหม่ทุกครั้ง
        // (ตัว access token ฝั่ง LINE อายุสั้นกว่านั้น แต่ authenticate_subscription! verify กับ LINE ทุกครั้งอยู่แล้ว)
        document.cookie = `line_lagnara=${accessToken}; path=/; max-age=${30 * 24 * 60 * 60}`

        // /liff เท่านั้นที่อ่าน redirect หลัง liff.init() เสร็จ (LINE เก็บ query ไว้ใน liff.state คืนค่าตอนนี้)
        const target = readRedirectParam ? safeRedirect() : redirectUrl

        // Another session cookie will be set from server side after querySubscription
        const subscription = await querySubscription(profile.userId)
        if (subscription) {
          let isDisplayNameChange = subscription.line_display_name != profile.displayName
          let isPhotoChange = subscription.line_picture_url != profile.pictureUrl
          if(isDisplayNameChange || isPhotoChange) {
            await updateLineProfileToSubscription(subscription.id, profile)
          }

          // มีหน้าปลายทาง (มาจาก /liff) ไปเลย — เดิม reload() ก่อนแล้วชนกับ href
          // ทำให้บางเครื่องโหลดหน้า /liff ซ้ำทั้งรอบ (SDK + คุยกับ LINE ใหม่หมด) ก่อนถึงหน้าจริง
          if (target) {
            window.location.href = target
          } else if (isDisplayNameChange || isPhotoChange) {
            window.location.reload() // หน้าเดิม: รีโหลดให้ชื่อ/รูปใหม่ขึ้น
          }
        } else {
          window.location.href = "/subscriptions/sign_up"
        }
      })
    })
    .catch(() => {
      // โหลด SDK / liff.init ล้ม (เน็ตสะดุด/สถานะ LIFF ในเครื่องเพี้ยน) — เดิมค้างจอหมุนตลอดกาล
      // หน้าเนื้อหาปล่อยผ่านได้ (session เซิร์ฟเวอร์ยังพาไปต่อ) แต่หน้า /liff ต้องมีทางไปต่อ
      if (!inClientOnly) { showLiffLoginProblem(liffId) }
    })
}

// เปลี่ยนสแปลช "กำลังเข้าสู่ระบบ" เป็นข้อความบอกปัญหา + ปุ่มลองใหม่ (เปิด LIFF URL ถาวร
// ให้ LINE ทำ auto-login ใหม่ทั้งรอบ) — ดีกว่าปล่อยผู้ใช้ค้างจอหมุนหรือเด้งไปจอ LINE 400
function showLiffLoginProblem(liffId) {
  const status = document.querySelector("#liff-login [role='status']")
  if (status == null) { return }
  sessionStorage.removeItem("liffRestarted") // กดลองใหม่แล้วให้สิทธิ์ restart อัตโนมัติอีกรอบ
  status.innerHTML = `
    <p class="text-lg font-semibold tracking-wide text-gold-soft">เข้าสู่ระบบไม่สำเร็จ</p>
    <p class="mt-2 text-sm text-gray-400 leading-relaxed">การเชื่อมต่อกับ LINE มีปัญหาชั่วคราว<br>แตะปุ่มด้านล่างเพื่อลองอีกครั้ง</p>
    <a href="https://liff.line.me/${liffId}" class="mt-5 inline-block px-8 py-2.5 rounded-full border border-gold-soft text-gold-soft font-semibold">ลองอีกครั้ง</a>`
}

async function updateLineProfileToSubscription(id, profile) {
  const url = `/subscriptions/${id}/update_line_profile`
  const resp = await fetch(url, {
    method: "PATCH",
    headers: {
      Authorization: 'Token token=""',
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      line_display_name: profile.displayName,
      line_picture_url: profile.pictureUrl,
    })
  })
  if (resp.status == 200) {
    const data = resp.json()
    return data
  } else {
    return false
  }
}

document.addEventListener("turbo:load", function() {
  // หน้า /liff (สแปลช #liff-login) เริ่ม LIFF flow ทันทีที่โหลด
  // เคยมีจอต้อนรับให้กดปุ่มก่อนเพื่อคุมจังหวะจอ "Allow access" ของ LINE — แต่ LINE ขอสิทธิ์ที่ระดับ
  // liff.line.me ก่อนหน้านี้จะโหลดเสมอ กดปุ่มอีกครั้งจึงไม่ได้อะไรนอกจากเพิ่มขั้น
  // บริบทก่อนจอ Allow ย้ายไปอยู่การ์ดชวนสมัครในแชทแทน (LineSignupInvite)
  if (document.getElementById("liff-login")) {
    initLiffAndSetSessionSubscription("liff-login", null, true, false)
  }
})

